import { render, staticRenderFns } from "./AbsaBankForm.vue?vue&type=template&id=01969705"
import script from "./AbsaBankForm.vue?vue&type=script&lang=js"
export * from "./AbsaBankForm.vue?vue&type=script&lang=js"
import style0 from "./AbsaBankForm.vue?vue&type=style&index=0&id=01969705&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports